export default {
    padding: 1,
};
